import type { CrossroadsLog } from '@/api/hooks/useIntegrationLogs'

export function getResponsibleTenant(log: CrossroadsLog): string | null {
  if (!log || log.detail.category !== 'mapping') {
    return null
  }

  const mappingErrorTenant = log.detail.detail.tenant
  if (mappingErrorTenant) return mappingErrorTenant

  return null
}

export function canFixMapping(
  log: CrossroadsLog,
  selectedTenantName: string | undefined,
): boolean {
  if (log.detail.category !== 'mapping') return false
  const responsibleTenant = getResponsibleTenant(log)
  return selectedTenantName === responsibleTenant
}

export function buildFixMappingUrl(log: CrossroadsLog): string | null {
  if (log.detail.category !== 'mapping') {
    return null
  }

  // Type assertion to include mapping_source_name which exists in API but not yet in generated types
  const mappingError = log.detail.detail as typeof log.detail.detail & {
    mapping_source_name?: string | null
  }

  const searchParams = new URLSearchParams()

  let entityType = mappingError.mapping_entity_type || 'unknown'
  if (entityType === 'unknown' && mappingError?.goids?.length) {
    const prefix = mappingError.goids[0].split(':')[0]
    const goidTypeMap: Record<string, string> = {
      terminal: 'terminal',
      site: 'site',
      tank: 'site',
      product: 'product',
      company: 'counterparty',
      tenant: 'counterparty',
    }
    entityType = goidTypeMap[prefix] ?? 'unknown'
  }
  searchParams.set('type', entityType)
  if (mappingError?.goids?.length) {
    searchParams.set('go_ids', mappingError.goids.join(','))
  }
  if (mappingError?.mapping_source_ids?.length) {
    searchParams.set('source_ids', mappingError.mapping_source_ids.join(','))
  }

  // Add action and prefill params when expected fix is to create a new mapping
  if (mappingError.expected_fixes?.includes('create_new_mapping')) {
    searchParams.set('action', 'create_mapping')
    if (mappingError.mapping_entity_type) {
      searchParams.set('prefill_type', mappingError.mapping_entity_type)
    }
    if (mappingError.mapping_source_ids?.[0]) {
      searchParams.set('prefill_source_id', mappingError.mapping_source_ids[0])
    }
    if (mappingError.mapping_source_system) {
      searchParams.set(
        'prefill_source_system',
        mappingError.mapping_source_system,
      )
    }
    if (mappingError.mapping_source_name) {
      searchParams.set('prefill_source_name', mappingError.mapping_source_name)
    }
  }

  return `/integration-management/reference-data?${searchParams.toString()}`
}
